import { config } from "zod";

/**
 * Zod compile ses schémas avec `new Function` quand l'environnement le permet.
 * Sous la politique de contenu servie par nginx (pas de `unsafe-eval`), la
 * tentative échoue : zod retombe sur l'interprétation et l'application marche,
 * mais le navigateur journalise une violation de CSP à chaque chargement.
 *
 * `jitless` supprime la sonde. Réglage propre au navigateur : côté API, Bun
 * n'a pas de CSP et garde la compilation.
 */
config({ jitless: true });
